import { useState, useEffect, useCallback } from 'react';
import interviewTemplateService from '../services/interviewTemplateService';
import i18n from '../i18n/config';
import { InterviewTemplate } from '../types'; // Utiliser InterviewTemplate au lieu de InterviewTemplateRead

interface UseInterviewTemplatesReturn {
  templates: InterviewTemplate[];
  isLoading: boolean;
  error: string | null;
  fetchTemplates: () => Promise<void>; // Export fetch function if manual refresh is needed
}

export function useInterviewTemplates(filterType?: 'audit' | 'cadrage' | null): UseInterviewTemplatesReturn {
  const [templates, setTemplates] = useState<InterviewTemplate[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTemplates = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // Passer le filtre au service
      const data = await interviewTemplateService.getAll(filterType);
      setTemplates(data || []);
    } catch (err: any) {
      console.error("Error fetching interview templates:", err);
      setError(err.response?.data?.detail || err.message || i18n.t('errors.interview.fetchTemplatesFailed'));
      setTemplates([]); // Reset on error
    } finally {
      setIsLoading(false);
    }
  }, [filterType]); // Refetch if filterType changes

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]); // Trigger fetch on mount and when fetchTemplates changes

  return {
    templates,
    isLoading,
    error,
    fetchTemplates, // Return fetch function
  };
}
